export class ModalHorizontalSize {
	static Fit = 'w-fit'
	static Full = 'w-full'
}

export class ModalVerticalSize {
	static Fit = 'h-fit'
	static Full = 'h-full'
}